import { getCookie } from '@jouzen/ecom-utils';
import { env } from 'next-runtime-env';

import { decodeTokenToEmail } from '@/utils/decodeToken';

interface GetEmailFromSessionResponse {
  email: string;
  type: string;
}
/**
 * Returns the email of the current user, based on the stored OAuth `id_token`.
 * It also verifies that a session cookie (`access_token`) exists.
 *
 * @returns The email address and the type of session the user is in
 */
export const getEmailFromSession = (): GetEmailFromSessionResponse => {
  const isNotProd = env('NEXT_PUBLIC_OURA_ENV') !== 'production';
  const fakeSession = getCookie('fake_session');
  const session = getCookie('session');
  const idToken = getCookie('id_token');

  if (fakeSession && isNotProd) {
    return { email: fakeSession, type: 'fake_session' };
  }

  if (session && idToken) {
    return { email: decodeTokenToEmail(idToken), type: 'session' };
  }

  return { email: '', type: '' };
};
